<header class="header" [@fadeIn]>
  <div class="background-logo">
    <img [src]="'../../assets/img/arrow-' + (isLight ? 'light' : 'dark') + '.svg'" alt="arrows" />
  </div>
  <div class="header-top">
    <h1 class="header-title">{{ title }}</h1>
    <div class="header-icons">
      <div class="notification-icon" *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'ADMIN']">
        <app-icam-icon iconName="bell" class="icon-bell" [isDefault]="true" />
        @if (brokenMachinesCount > 0) {
          <span class="notification-count">{{ brokenMachinesCount }}</span>
        }
      </div>
      <div
        class="user-info"
        (click)="toggleDropdown()"
        (keydown.enter)="toggleDropdown()"
        tabindex="0"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="user-icon-wrapper">
          @if (userImage) {
            <img [src]="userImage" class="user-image" alt="user profile" />
          } @else {
            <app-icam-icon [iconName]="'user'" class="icon-user" />
          }
        </div>
        @if (profile && profile.firstName) {
          <span class="username">{{ profile.firstName | titlecase }}</span>
        }
      </div>
      @if (dropdownOpen) {
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          @if (isImpersonating) {
            <a class="dropdown-item" (click)="onResetImpersonification()" (keydown.enter)="onResetImpersonification()" tabindex="0" role="button">
              Torna a {{ originalUserEmail }}
            </a>
            <div class="dropdown-divider"></div>
          }
          <a class="dropdown-item" routerLink="/account">{{ 'COMMON.ACCOUNT' | translate }}</a>
          @if (profile.companyGroupId) {
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/company-group-users">
              {{ companyGroupName || ('HEADER.VIEW_AS' | translate) }}
            </a>
          }
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" (click)="onLogout()" (keydown.enter)="onLogout()" tabindex="0" role="button">{{
            'COMMON.LOGOUT' | translate
          }}</a>
        </div>
      }
    </div>
  </div>
  <hr class="header-line" [ngClass]="isLight ? 'light' : 'dark'" />
  <p class="header-subtitle">{{ subtitle }}</p>
</header>
